import { THEME_ATTRIBUTION } from '../../fields'

// Generate theme attribution data for flow diagram
export const generateThemeAttributionData = report => {
  const themeAttributionData = report?.[THEME_ATTRIBUTION]

  if (!themeAttributionData || themeAttributionData.length === 0) {
    return []
  }

  // Sort by total_impact (highest first) for better visual hierarchy
  return themeAttributionData
    .filter(theme => theme.total_impact && theme.total_impact > 0)
    .sort((a, b) => b.total_impact - a.total_impact)
}
